import { c as _c } from "react/compiler-runtime";
import { skipToken, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { trpcClient } from "@/clients/trpcClient";
import { isModerationConflict, MODERATION_CONFLICT_MESSAGE } from "@/lib/utils/moderationConflict";
import { parseRouteId } from "@/lib/utils/routeId";
import { trpc } from "@/router";
export function useFeatureDetail() {
  const $ = _c(67);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      from: "/_app/admin/feature/$id"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    id
  } = useParams(t0);
  const featureId = parseRouteId(id);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {
    data: feature,
    isLoading
  } = useQuery(trpc.features.byId.queryOptions(featureId ? {
    id: featureId
  } : skipToken));
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = trpc.features.types.queryOptions();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: t2
  } = useQuery(t1);
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const featureTypes = t3;
  let t4;
  if ($[4] !== feature?.assessment?.data) {
    t4 = feature?.assessment?.data ?? {};
    $[4] = feature?.assessment?.data;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const assessmentData = t4;
  const [featureTypeId, setFeatureTypeId] = useState("");
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      doorType: "unknown",
      estimatedDoorWidth: "unknown",
      hasDoorThreshold: false,
      hasSteps: false,
      stepCount: null,
      hasRamp: false,
      hasHandrails: false,
      hasAutomaticDoorOpener: false,
      surfaceType: "unknown",
      entranceLevel: "ground_level",
      hasContrastMarkings: false,
      hasIntercom: false,
      additionalNotes: "",
      parkingSpaceType: "unknown",
      hasWheelchairSign: false,
      hasGroundMarkings: false,
      hasKerbCut: false,
      isCovered: false,
      paymentType: "unknown"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const [form, setForm] = useState(t5);
  let t6;
  let t7;
  if ($[7] !== feature) {
    t6 = () => {
      if (feature) {
        setFeatureTypeId(String(feature.featureType.id));
        if (feature.assessment?.data) {
          const d = feature.assessment.data;
          setForm({
            doorType: d.doorType ?? "unknown",
            estimatedDoorWidth: d.estimatedDoorWidth ?? "unknown",
            hasDoorThreshold: d.hasDoorThreshold ?? false,
            hasSteps: d.hasSteps ?? false,
            stepCount: d.stepCount ?? null,
            hasRamp: d.hasRamp ?? false,
            hasHandrails: d.hasHandrails ?? false,
            hasAutomaticDoorOpener: d.hasAutomaticDoorOpener ?? false,
            surfaceType: d.surfaceType ?? "unknown",
            entranceLevel: d.entranceLevel ?? "ground_level",
            hasContrastMarkings: d.hasContrastMarkings ?? false,
            hasIntercom: d.hasIntercom ?? false,
            additionalNotes: d.additionalNotes ?? "",
            parkingSpaceType: d.parkingSpaceType ?? "unknown",
            hasWheelchairSign: d.hasWheelchairSign ?? false,
            hasGroundMarkings: d.hasGroundMarkings ?? false,
            hasKerbCut: d.hasKerbCut ?? false,
            isCovered: d.isCovered ?? false,
            paymentType: d.paymentType ?? "unknown"
          });
        }
      }
    };
    t7 = [feature];
    $[7] = feature;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  if ($[10] !== featureId) {
    t8 = () => {
      if (featureId === null) {
        throw new Error("Invalid feature id");
      }
      return featureId;
    };
    $[10] = featureId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const requireFeatureId = t8;
  let t9;
  if ($[12] !== queryClient) {
    t9 = () => queryClient.invalidateQueries({
      queryKey: [["features"]]
    });
    $[12] = queryClient;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const invalidate = t9;
  let t10;
  if ($[14] !== assessmentData || $[15] !== featureTypeId || $[16] !== form || $[17] !== requireFeatureId) {
    t10 = () => trpcClient.features.updateAssessment.mutate({
      featureId: requireFeatureId(),
      featureTypeId: parseInt(featureTypeId),
      data: {
        ...assessmentData,
        ...form,
        confidence: 1,
        needsHumanReview: false
      }
    });
    $[14] = assessmentData;
    $[15] = featureTypeId;
    $[16] = form;
    $[17] = requireFeatureId;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== invalidate) {
    t11 = () => {
      toast.success("Sparad");
      invalidate();
    };
    $[19] = invalidate;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = {
      mutationFn: t10,
      onSuccess: t11
    };
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const saveMutation = useMutation(t12);
  let t13;
  if ($[24] !== feature?.status || $[25] !== requireFeatureId) {
    t13 = () => trpcClient.features.moderate.mutate({
      id: requireFeatureId(),
      action: "approve",
      expectedStatus: feature?.status
    });
    $[24] = feature?.status;
    $[25] = requireFeatureId;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  let t15;
  if ($[27] !== invalidate) {
    t14 = () => {
      toast.success("Godk\xE4nd");
      invalidate();
    };
    t15 = err => {
      if (isModerationConflict(err)) {
        toast.error(MODERATION_CONFLICT_MESSAGE);
        invalidate();
        return;
      }
      const message = err instanceof Error && err.message.includes("PARENT_NOT_APPROVED") ? "Platsen m\xE5ste godk\xE4nnas innan entr\xE9n kan godk\xE4nnas." : "Kunde inte godk\xE4nna";
      toast.error(message);
    };
    $[27] = invalidate;
    $[28] = t14;
    $[29] = t15;
  } else {
    t14 = $[28];
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t14 || $[32] !== t15) {
    t16 = {
      mutationFn: t13,
      onSuccess: t14,
      onError: t15
    };
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const approveMutation = useMutation(t16);
  let t17;
  if ($[34] !== feature?.status || $[35] !== requireFeatureId) {
    t17 = () => trpcClient.features.moderate.mutate({
      id: requireFeatureId(),
      action: "reject",
      expectedStatus: feature?.status
    });
    $[34] = feature?.status;
    $[35] = requireFeatureId;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== navigate) {
    t18 = () => {
      toast.success("Avvisad");
      navigate({
        to: "/admin/granska"
      });
    };
    $[37] = navigate;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== invalidate) {
    t19 = err_0 => {
      if (isModerationConflict(err_0)) {
        toast.error(MODERATION_CONFLICT_MESSAGE);
        invalidate();
        return;
      }
      toast.error("Kunde inte avvisa");
    };
    $[39] = invalidate;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t17 || $[42] !== t18 || $[43] !== t19) {
    t20 = {
      mutationFn: t17,
      onSuccess: t18,
      onError: t19
    };
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  const rejectMutation = useMutation(t20);
  let t21;
  if ($[45] !== requireFeatureId) {
    t21 = () => trpcClient.features.deleteFeature.mutate({
      id: requireFeatureId()
    });
    $[45] = requireFeatureId;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== navigate) {
    t22 = () => {
      toast.success("Borttagen");
      navigate({
        to: "/admin/granska"
      });
    };
    $[47] = navigate;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t21 || $[50] !== t22) {
    t23 = {
      mutationFn: t21,
      onSuccess: t22
    };
    $[49] = t21;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  const deleteMutation = useMutation(t23);
  let t24;
  if ($[52] !== invalidate) {
    t24 = {
      mutationFn: _temp,
      onSuccess: () => {
        toast.success("Bild borttagen");
        invalidate();
      }
    };
    $[52] = invalidate;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  const deleteMediaMutation = useMutation(t24);
  let t25;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = (key, value) => setForm(p => ({
      ...p,
      [key]: value
    }));
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  const setFormField = t25;
  let t26;
  if ($[55] !== approveMutation || $[56] !== deleteMediaMutation || $[57] !== deleteMutation || $[58] !== feature || $[59] !== featureId || $[60] !== featureTypeId || $[61] !== featureTypes || $[62] !== form || $[63] !== isLoading || $[64] !== rejectMutation || $[65] !== saveMutation) {
    t26 = {
      featureId,
      feature,
      isLoading,
      featureTypes,
      featureTypeId,
      setFeatureTypeId,
      form,
      setFormField,
      saveMutation,
      approveMutation,
      rejectMutation,
      deleteMutation,
      deleteMediaMutation
    };
    $[55] = approveMutation;
    $[56] = deleteMediaMutation;
    $[57] = deleteMutation;
    $[58] = feature;
    $[59] = featureId;
    $[60] = featureTypeId;
    $[61] = featureTypes;
    $[62] = form;
    $[63] = isLoading;
    $[64] = rejectMutation;
    $[65] = saveMutation;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  return t26;
}
function _temp(mediaId) {
  return trpcClient.features.deleteMedia.mutate({
    id: mediaId
  });
}